import {
	CONTACT_DUPLICITY_CHECK,
	CONTACT_DUPLICITY_DONE,
	GO_TO_CUSTOMER_STEP,
	GO_TO_SUMMARY_STEP,
	RESET_ACTION,
	SUBMITTED_REGISTRATION_ACTION,
	SUBMITTED_REGISTRATION_ERROR_ACTION,
	SUBMITTING_REGISTRATION_ACTION,
	UPDATE_ACCORDIONS,
	UPDATE_BIRTHDAY_INPUT,
	UPDATE_CONSENT_CHECKBOX_INPUT,
	UPDATE_SELECT_INPUT,
	UPDATE_TEXT_INPUT,
	UPDATE_COUNTRY_ACTION,
	UPDATE_DELIVERY_SERVICE_ACTION,
	SET_REGISTRATION_DATA
} from '../../actions/RegistrationFormActions';
import RegistrationStep from '../../enums/RegistrationStep';
import CustomerStep from '../../components/blocks/raffleForm/CustomerStep';
import produce from 'immer';
import RaffleFormReducer from '../RaffleFormReducer';
import Countries from '../../enums/Countries';

export default class RegistrationFormReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 */
	static reduce(state = {}, action) {
		switch (action.type) {
			case CONTACT_DUPLICITY_CHECK:
				return produce(state, draftState => {
					draftState.checkingContactDuplicity = true;
				});
			case CONTACT_DUPLICITY_DONE:
				return produce(state, draftState => {
					RegistrationFormReducer.validateDuplicatedData(draftState, action);
					draftState.checkingContactDuplicity = false;
				});
			case UPDATE_TEXT_INPUT:
				return produce(state, draftState => {
					RegistrationFormReducer.updateInput(draftState, action);
				});
			case UPDATE_SELECT_INPUT:
				return produce(state, draftState => {
					RegistrationFormReducer.updateInput(draftState, action);
				});
			case UPDATE_CONSENT_CHECKBOX_INPUT:
				return produce(state, draftState => {
					RegistrationFormReducer.updateConsentCheckboxInput(draftState, action);
				});
			case UPDATE_BIRTHDAY_INPUT:
				return produce(state, draftState => {
					RegistrationFormReducer.updateInput(draftState, action);
				});
			case UPDATE_ACCORDIONS:
				return produce(state, draftState => {
					RegistrationFormReducer.updateAccordions(draftState, action);
				});
			case RESET_ACTION:
				return produce(state, draftState => {
					RegistrationFormReducer.resetFormData(draftState);
					draftState.registration = null;
					draftState.activeStep = RegistrationStep.CUSTOMER;
					draftState.checkedSteps = [];
					draftState.errors = [];
				});
			case GO_TO_CUSTOMER_STEP:
				return produce(state, draftState => {
					draftState.activeStep = RegistrationStep.CUSTOMER;
					draftState.checkedSteps = [];
				});
			case GO_TO_SUMMARY_STEP:
				return produce(state, draftState => {
					draftState.activeStep = RegistrationStep.SUMMARY;
					draftState.checkedSteps = [
						RegistrationStep.CUSTOMER.value
					];
					draftState.errors = [];
				});
			case SUBMITTING_REGISTRATION_ACTION:
				return produce(state, draftState => {
					draftState.submittingRegistration = true;
					draftState.checkedSteps = [
						RegistrationStep.CUSTOMER.value
					];
					draftState.errors = [];
				});
			case SUBMITTED_REGISTRATION_ACTION:
				return produce(state, draftState => {
					draftState.activeStep = RegistrationStep.PAYMENT;
					draftState.checkedSteps = [
						RegistrationStep.CUSTOMER.value,
						RegistrationStep.SUMMARY.value
					];
					draftState.submittingRegistration = false;
					draftState.registration = action.registration;
					draftState.errors = [];
				});
			case SET_REGISTRATION_DATA:
				return produce(state, draftState => {
					draftState.submittingRegistration = false;
					draftState.registration = action.registration;
				});
			case SUBMITTED_REGISTRATION_ERROR_ACTION:
				return produce(state, draftState => {
					draftState.activeStep = action.activeStep;
					draftState.submittingRegistration = false;
					draftState.errors = action.errors;
				});
			case UPDATE_DELIVERY_SERVICE_ACTION:
				return produce(state, draftState => {
					draftState.deliveryService = action.deliveryService;
				});
			case UPDATE_COUNTRY_ACTION:
				return produce(state, draftState => {
					draftState = RegistrationFormReducer.updateCountry(draftState, action.value);
					draftState.fields.city = RaffleFormReducer.updateTextInputState(draftState.fields.city, '', CustomerStep.inputs.city.validators);
					draftState.fields.streetName = RaffleFormReducer.updateTextInputState(draftState.fields.streetName, '', CustomerStep.inputs.streetName.validators);
					draftState.fields.houseNumber = RaffleFormReducer.updateTextInputState(draftState.fields.houseNumber, '', CustomerStep.inputs.houseNumber.validators);
					draftState.fields.additional = RaffleFormReducer.updateTextInputState(draftState.fields.additional, '', CustomerStep.inputs.additional.validators);
					RegistrationFormReducer.updateInput(draftState, { name: 'usState', data: { value: '', touched: false } });
					RegistrationFormReducer.updateInput(draftState, { name: 'caState', data: { value: '', touched: false } });
					RegistrationFormReducer.updateInput(draftState, { name: 'romanianCounty', data: { value: '', touched: false } });
					RegistrationFormReducer.updateInput(draftState, { name: 'romanianCity', data: { value: '', touched: false } });
				});
			default:
				return state;
		}
	}

	/**
	 * @param {object} draftState
	 * @param {object} action
	 */
	static validateDuplicatedData(draftState, action) {
		const fields = draftState.fields;
		let valid = true;

		if (action.errors.email) {
			fields.email.valid = false;
			fields.email.errors.push({ msg: 'This email address is already registered or is not valid. Please, use a different one.' });
			valid = false;
		}
		if (action.errors.phone) {
			fields.phone.valid = false;
			fields.phone.errors.push({ msg: 'This phone number is already registered. Please, use a different one.' });
			valid = false;
		}
		if (valid) {
			const accordions = draftState.accordions;
			accordions.contactAccordion.isOpen = false;
			accordions.contactAccordion.isVisible = true;
			accordions.aboutYouAccordion.isOpen = true;
			accordions.aboutYouAccordion.isVisible = true;
			accordions.deliveryAddressAccordion.isOpen = false;
			accordions.deliveryAddressAccordion.isVisible = false;
		}
	}

	/**
	 * @param {object} draftState
	 * @param {object} action
	 */
	static updateInput(draftState, action) {
		const { name, data } = action;
		const { touched, ...updatedData } = data;

		draftState.fields[name] = {
			...draftState.fields[name],
			...updatedData,
			touched: touched === true
		};

		RegistrationFormReducer.updateAccordionsValidity(draftState);
	}

	/**
	 * @param {object} draftState
	 * @param {object} action
	 */
	static updateConsentCheckboxInput(draftState, action) {
		const { name, data } = action;
		const { touched, ...updatedData } = data;

		draftState.fields.consents[name] = {
			...draftState.fields.consents[name],
			...updatedData,
			touched: touched === true
		};

		RegistrationFormReducer.updateAccordionsValidity(draftState);
	}

	static updateAccordionsValidity(draftState) {
		const accordions = draftState.accordions;
		const fields = draftState.fields;
		accordions.contactAccordion.isChecked = CustomerStep.isContactAccordionValid(fields);
		accordions.aboutYouAccordion.isChecked = CustomerStep.isAboutYouAccordionValid(fields);
		accordions.deliveryAddressAccordion.isChecked = CustomerStep.isDeliveryAddressAccordionValid(fields);
	}

	/**
	 * @param {object} draftState
	 * @param {object} action
	 */
	static updateAccordions(draftState, action) {
		const { data } = action;

		Object.keys(data).forEach(key => {
			draftState.accordions[key] = { ...data[key] };
		});
	}

	/**
	 * @param {object} state
	 * @param {string} value
	 */
	static updateCountry(state, value) {
		return produce(state, draftState => {
			// Get option matching the country
			const option = state.countries.find(country => country.value === value);
			// Get the first delivery service for given country..
			let deliveryService = null;
			if (option && option.deliveryServices && option.deliveryServices.length > 0) {
				deliveryService = option.deliveryServices[0];
			}
			// Update country select

			RegistrationFormReducer.updateInput(draftState, { name: 'country', data: { value, touched: true } });
			RegistrationFormReducer.updateInput(draftState, { name: 'postalCode', data: { value: '', touched: false, valid: false } });

			// Update delivery service
			draftState.deliveryService = deliveryService;
			// Handle specific countries
			if (value === Countries.ROMANIA.value) {
				// When we choose Romania, reset US State selection
				RegistrationFormReducer.updateInput(draftState, { name: 'usState', data: { value: '', touched: false } });
				RegistrationFormReducer.updateInput(draftState, { name: 'caState', data: { value: '', touched: false } });
				RegistrationFormReducer.updateInput(draftState, { name: 'postalCode', data: { value: '', touched: false, valid: true } });
			}
			else if (value === Countries.USA.value || value === Countries.CANADA.value ) {
				// When we choose USA or CANADA reset romanian county / city
				RegistrationFormReducer.updateInput(draftState, { name: 'romanianCounty', data: { value: '', touched: false } });
				RegistrationFormReducer.updateInput(draftState, { name: 'romanianCity', data: { value: '', touched: false } });
			}
			if (value === Countries.HONGKONG.value) {
				RegistrationFormReducer.updateInput(draftState, { name: 'postalCode', data: { value: '', touched: false, valid: true } });
			}
		});
	}

	/**
	 * @param {object} draftState
	 * @return {object}
	 */
	static resetFormData(draftState) {
		draftState.fields = RaffleFormReducer.createDefaultFieldsState();
		draftState.accordions = RaffleFormReducer.createDefaultAccordionState();
	}
}



// WEBPACK FOOTER //
// ./reducers/registrationForm/RegistrationFormReducer.js